import { Component, signal } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';

@Component({
  selector: 'app-title-tooltip',
  standalone: false,
  templateUrl: './title-tooltip.component.html',
  styleUrl: './title-tooltip.component.scss',
  host: { class: 'ag-tooltip' }, //garde le style du tooltip AG par défaut (sinon ag-tooltip-custom)
})
export class TitleTooltipComponent implements ITooltipAngularComp {
  readonly title = signal<string>('');
  readonly text = signal<string>('');

  agInit(params: ITooltipParams): void {
    //header : titre en gras au-dessus du titleTooltip ; cellule : valeur seule
    if (params.location === 'header') {
      this.title.set(params.colDef?.headerName ?? '');
    }
    this.text.set(params.value ?? '');
  }
}
